var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ProductPlansArray extends Array {
    constructor(productPlans) {
        super(...(Array.isArray(productPlans) ? productPlans : []));
        Object.setPrototypeOf(this, Object.create(ProductPlansArray.prototype));
    }
    getProduct(product) {
        return this.find(({ name }) => name === product);
    }
    getRequestParams() {
        return this.map(({ name, type, params, hardCap }) => ({ name, type, params, hardCap }));
    }
    clone() {
        return new ProductPlansArray([...this]);
    }
    getTotalPrice(taxFees = 0) {
        const productPrices = this.map(product => product?.price ?? NaN);
        return productPrices.reduce((totalPrice, productPrice) => totalPrice + productPrice, 0) + (taxFees ?? 0);
    }
}
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], ProductPlansArray.prototype, "getProduct", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", ProductPlansArray)
], ProductPlansArray.prototype, "getRequestParams", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", ProductPlansArray)
], ProductPlansArray.prototype, "clone", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Number)
], ProductPlansArray.prototype, "getTotalPrice", null);
//# sourceMappingURL=product-plan-array.js.map